<template>
  <div radius="24" class="loading">
    <svg width="48" height="48"
      style="pointer-events: none;">
      <circle cx="24" cy="3" r="1.5" fill="rgba(91,83,255,1"></circle>
      <path fill="none" stroke="rgba(91,83,255,0)" stroke-width="3" d="M 39.606 9.9483 A 21 21 0 0 0 37.4985 7.9131">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.025)" stroke-width="3"
        d="M 41.4098 12.2569 A 21 21 0 0 0 39.606 9.9483"></path>
      <path fill="none" stroke="rgba(91,83,255,0.05)" stroke-width="3"
        d="M 42.8747 14.7942 A 21 21 0 0 0 41.4098 12.2569"></path>
      <path fill="none" stroke="rgba(91,83,255,0.075)" stroke-width="3"
        d="M 43.9722 17.5106 A 21 21 0 0 0 42.8747 14.7942"></path>
      <path fill="none" stroke="rgba(91,83,255,0.1)" stroke-width="3"
        d="M 44.681 20.3534 A 21 21 0 0 0 43.9722 17.5106"></path>
      <path fill="none" stroke="rgba(91,83,255,0.125)" stroke-width="3"
        d="M 44.9872 23.2671 A 21 21 0 0 0 44.681 20.3534"></path>
      <path fill="none" stroke="rgba(91,83,255,0.15)" stroke-width="3"
        d="M 44.885 26.1951 A 21 21 0 0 0 44.9872 23.2671"></path>
      <path fill="none" stroke="rgba(91,83,255,0.175)" stroke-width="3"
        d="M 44.3762 29.0804 A 21 21 0 0 0 44.885 26.1951"></path>
      <path fill="none" stroke="rgba(91,83,255,0.2)" stroke-width="3"
        d="M 43.4709 31.8667 A 21 21 0 0 0 44.3762 29.0804"></path>
      <path fill="none" stroke="rgba(91,83,255,0.225)" stroke-width="3"
        d="M 42.1865 34.5 A 21 21 0 0 0 43.4709 31.8667"></path>
      <path fill="none" stroke="rgba(91,83,255,0.25)" stroke-width="3" d="M 40.5482 36.9289 A 21 21 0 0 0 42.1865 34.5">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.275)" stroke-width="3"
        d="M 38.5878 39.1061 A 21 21 0 0 0 40.5482 36.9289"></path>
      <path fill="none" stroke="rgba(91,83,255,0.3)" stroke-width="3"
        d="M 36.3435 40.9894 A 21 21 0 0 0 38.5878 39.1061"></path>
      <path fill="none" stroke="rgba(91,83,255,0.325)" stroke-width="3"
        d="M 33.8589 42.5419 A 21 21 0 0 0 36.3435 40.9894"></path>
      <path fill="none" stroke="rgba(91,83,255,0.35)" stroke-width="3"
        d="M 31.1824 43.7335 A 21 21 0 0 0 33.8589 42.5419"></path>
      <path fill="none" stroke="rgba(91,83,255,0.375)" stroke-width="3"
        d="M 28.3661 44.5411 A 21 21 0 0 0 31.1824 43.7335"></path>
      <path fill="none" stroke="rgba(91,83,255,0.4)" stroke-width="3"
        d="M 25.4649 44.9488 A 21 21 0 0 0 28.3661 44.5411"></path>
      <path fill="none" stroke="rgba(91,83,255,0.425)" stroke-width="3"
        d="M 22.5351 44.9488 A 21 21 0 0 0 25.4649 44.9488"></path>
      <path fill="none" stroke="rgba(91,83,255,0.45)" stroke-width="3"
        d="M 19.6339 44.5411 A 21 21 0 0 0 22.5351 44.9488"></path>
      <path fill="none" stroke="rgba(91,83,255,0.475)" stroke-width="3"
        d="M 16.8176 43.7335 A 21 21 0 0 0 19.6339 44.5411"></path>
      <path fill="none" stroke="rgba(91,83,255,0.5)" stroke-width="3"
        d="M 14.1411 42.5419 A 21 21 0 0 0 16.8176 43.7335"></path>
      <path fill="none" stroke="rgba(91,83,255,0.525)" stroke-width="3"
        d="M 11.6565 40.9894 A 21 21 0 0 0 14.1411 42.5419"></path>
      <path fill="none" stroke="rgba(91,83,255,0.55)" stroke-width="3"
        d="M 9.4122 39.1061 A 21 21 0 0 0 11.6565 40.9894"></path>
      <path fill="none" stroke="rgba(91,83,255,0.575)" stroke-width="3"
        d="M 7.4518 36.9289 A 21 21 0 0 0 9.4122 39.1061"></path>
      <path fill="none" stroke="rgba(91,83,255,0.6)" stroke-width="3" d="M 5.8135 34.5 A 21 21 0 0 0 7.4518 36.9289">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.625)" stroke-width="3" d="M 4.5291 31.8667 A 21 21 0 0 0 5.8135 34.5">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.65)" stroke-width="3"
        d="M 3.6238 29.0804 A 21 21 0 0 0 4.5291 31.8667"></path>
      <path fill="none" stroke="rgba(91,83,255,0.675)" stroke-width="3"
        d="M 3.115 26.1951 A 21 21 0 0 0 3.6238 29.0804"></path>
      <path fill="none" stroke="rgba(91,83,255,0.7)" stroke-width="3" d="M 3.0128 23.2671 A 21 21 0 0 0 3.115 26.1951">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.725)" stroke-width="3"
        d="M 3.319 20.3534 A 21 21 0 0 0 3.0128 23.2671"></path>
      <path fill="none" stroke="rgba(91,83,255,0.75)" stroke-width="3" d="M 4.0278 17.5106 A 21 21 0 0 0 3.319 20.3534">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.775)" stroke-width="3"
        d="M 5.1253 14.7942 A 21 21 0 0 0 4.0278 17.5106"></path>
      <path fill="none" stroke="rgba(91,83,255,0.8)" stroke-width="3" d="M 6.5902 12.2569 A 21 21 0 0 0 5.1253 14.7942">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.825)" stroke-width="3" d="M 8.394 9.9483 A 21 21 0 0 0 6.5902 12.2569">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.85)" stroke-width="3" d="M 10.5015 7.9131 A 21 21 0 0 0 8.394 9.9483">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.875)" stroke-width="3"
        d="M 12.8717 6.191 A 21 21 0 0 0 10.5015 7.9131"></path>
      <path fill="none" stroke="rgba(91,83,255,0.9)" stroke-width="3" d="M 15.4585 4.8155 A 21 21 0 0 0 12.8717 6.191">
      </path>
      <path fill="none" stroke="rgba(91,83,255,0.925)" stroke-width="3"
        d="M 18.2116 3.8135 A 21 21 0 0 0 15.4585 4.8155"></path>
      <path fill="none" stroke="rgba(91,83,255,0.95)" stroke-width="3"
        d="M 21.0774 3.2044 A 21 21 0 0 0 18.2116 3.8135"></path>
      <path fill="none" stroke="rgba(91,83,255,0.975)" stroke-width="3" d="M 24 3 A 21 21 0 0 0 21.0774 3.2044"></path>
    </svg>
  </div>
</template>

<style lang="stylus" scoped>
.loading {
  width: 48px;
  height: 48px;
  animation: 0.8s linear 0s infinite normal none running rotate
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
100% {
    transform: rotate(360deg);
  }
}
</style>